import {getStationCode} from "../../network/NetworkUtil";
import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {logOperationalMetric} from "../../util/Util";

const metricProcessName = "SCC_RECEIVE";
export function getPackages(filter, dispatcher, lineHaulId, containerId, packageState, filterIdentifier, isCPTFilterEnabled) {
    let filterMap;
    if(isCPTFilterEnabled){
        filterMap = {
            [filterIdentifier]: filter.CPT,
            "EAD": filter.EAD,
            "OtherAttributes": filter.OtherAttributes,
            "Cluster": filter.Cluster,
            "PackageSize": filter.PackageSize
        };
    }
    else{
        filterMap = {
            "Cycle": filter.Cycle,
            "EAD": filter.EAD,
            "OtherAttributes": filter.OtherAttributes,
            "Cluster": filter.Cluster,
            "PackageSize": filter.PackageSize
        };
    }
    const request = {
        nodeId: getStationCode(),
        lineHaulId: lineHaulId,
        containerId: containerId,
        packageState: packageState,
        filters: filterMap
    };
    getPackageList(dispatcher, request);
}

export function fetchCPTFilter(dispatcher) {
    getCPTFilterValues(dispatcher);
}

function getCPTDataAPIGatewayRequest(request) {
    return {
        resourcePath: "/ivs/getStationCPTs",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

async function getCPTFilterValues(dispatcher) {
    const request = {
        nodeId: getStationCode(),
    }
    const args = getCPTDataAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getCPTData", true);
            const output = result.data;
            dispatcher({type: "ASSIGN_LABEL", data: {CPTLabel: output.CPTTypeLabelKey}})
            dispatcher({type: "ASSIGN_FILTER_IDENTIFIER", data: {filterIdentifier: output.filterIdentifier}})
        } else {
            logOperationalMetric(startTime, metricProcessName, "getCPTData", false);
        }
    });
}

function getPackageListAPIGatewayRequest(request) {
    return {
        resourcePath: "/ivs/getPackageList",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

async function getPackageList(dispatcher, request) {
    const args = getPackageListAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getPackageList", true);
            let output = result.data.packageList;
            const packageMetrics = output.map(packageMetric => {
                packageMetric['minInState'] = parseInt(packageMetric['minInState'], 10);
                return packageMetric;
            })
            dispatcher({type: "RECEIVE_DATA", data: {
                packageList: packageMetrics
            }});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getPackageList", false);
        }
    });
}




// WEBPACK FOOTER //
// ./src/components/package/network/PackageListNetworkAPI.js